module.exports = __webpack_public_path__ + "img/sence_asi_6.5aa8df69.png";